/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MobileRegistrationTokenDto, UpdateMobileRegistrationTokenRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMobileRegistrationTokenController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-mobile-registration-token-controller
   * @name Save
   * @request POST:/api/v1/mobile-registration-token
   */
  save = (data: UpdateMobileRegistrationTokenRequest, params: RequestParams = {}) =>
    this.http.request<MobileRegistrationTokenDto, any>({
      path: `/v1/mobile-registration-token`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static savePath = '/v1/mobile-registration-token'
  static saveMethod = 'POST'
  /**
   * No description
   *
   * @tags api-mobile-registration-token-controller
   * @name Delete
   * @request DELETE:/api/v1/mobile-registration-token/{registrationToken}
   */
  delete = (registrationToken: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/mobile-registration-token/${registrationToken}`,
      method: 'DELETE',
      ...params,
    })

  static deletePath = '/v1/mobile-registration-token/${registrationToken}'
  static deleteMethod = 'DELETE'
}
